import { SaleOrder, SaleOrderStatus } from 'models/sale-order';
import React from 'react';
import './SaleOrderStatusBar.scss';

export interface SaleOrderStatusBarProps {
  order: SaleOrder;
}

export default function SaleOrderStatusBar({ order }: SaleOrderStatusBarProps) {

  return (
    <>
      { order.docState === 'T' ? <div className='sale-order-status-bar__container'>
        <div className='sale-order-status-bar__item sale-order-status-bar__item--danger'> Tühistatud</div>
      </div> : null}
      {
        order.docState !== 'T' ? order.isQuote ? <div className='sale-order-status-bar__container'>
        <div className={'sale-order-status-bar__item sale-order-status-bar__item--success'}>
          Pakkumus saadetud
        </div>
        <div className={'sale-order-status-bar__item' + 
        ( order.docState === 'MV2' ? ' sale-order-status-bar__item--success' : ' sale-order-status-bar__item--warning')}>
          Pakkumus koostamisel
        </div>
        <div className={'sale-order-status-bar__item' + (order.docState === 'MV2' ? ' sale-order-status-bar__item--warning' : '')}>
          Kinnitamise ootel
        </div>
      </div> :
      <div className='sale-order-status-bar__container'>
        <div className={'sale-order-status-bar__item sale-order-status-bar__item--success'}>
          { order.docState === SaleOrderStatus.ORDER_CONFIRMED ? 'Pakkumus kinnitatud' : 'Tellimus esitatud' }
        </div>
        <div className={'sale-order-status-bar__item' + 
        ( (order.docState === 'W' && order.transporterCode === 'TT') || order.docState === 'A' ? ' sale-order-status-bar__item--success' : '')}>
          Vedu planeerimisel
        </div>
        <div className={'sale-order-status-bar__item' + (order.docState === 'A' ? ' sale-order-status-bar__item--success' : '')}>
          Tellimus väljastatud
        </div>
      </div> : null
      }
    </>
  )
}